// src/marketing.ts
var IMOBDESK_TOKENS_META = {
  source: "@imobdesk/design-tokens",
  api: "/api/design-tokens"
};
var SURFACE_HERO_DARK_INDO = "relative overflow-hidden rounded-2xl bg-gradient-to-br from-slate-950 via-indigo-950 to-slate-950 animate-gradient";
var AUTH_LOGIN_SCENES = [
  {
    id: "hero-indigo",
    base: "bg-linear-to-br from-slate-950 via-indigo-950 to-slate-950 animate-gradient",
    orbs: [
      "bg-indigo-500/30",
      "bg-fuchsia-500/22",
      "bg-emerald-400/20",
      "bg-cyan-400/16",
      "bg-indigo-700/20"
    ]
  },
  {
    id: "hero-emerald",
    base: "bg-linear-to-br from-slate-950 via-emerald-950 to-slate-950 animate-gradient",
    orbs: [
      "bg-emerald-500/28",
      "bg-teal-500/20",
      "bg-green-400/18",
      "bg-cyan-400/14",
      "bg-emerald-700/18"
    ]
  },
  {
    id: "hero-teal",
    base: "bg-linear-to-br from-slate-950 via-teal-950 to-slate-950 animate-gradient",
    orbs: [
      "bg-teal-500/26",
      "bg-cyan-500/20",
      "bg-emerald-400/18",
      "bg-sky-400/14",
      "bg-teal-700/18"
    ]
  },
  {
    id: "hero-violet",
    base: "bg-linear-to-br from-slate-950 via-violet-950 to-indigo-950 animate-gradient",
    orbs: [
      "bg-violet-500/28",
      "bg-purple-500/22",
      "bg-fuchsia-400/18",
      "bg-indigo-400/16",
      "bg-violet-700/20"
    ]
  },
  {
    id: "hero-purple",
    base: "bg-linear-to-br from-slate-950 via-purple-950 to-slate-950 animate-gradient",
    orbs: [
      "bg-purple-500/26",
      "bg-fuchsia-500/22",
      "bg-violet-400/18",
      "bg-pink-400/14",
      "bg-purple-700/18"
    ]
  },
  {
    id: "hero-cyan",
    base: "bg-linear-to-br from-slate-950 via-cyan-950 to-slate-950 animate-gradient",
    orbs: [
      "bg-cyan-500/26",
      "bg-blue-500/20",
      "bg-sky-400/18",
      "bg-teal-400/14",
      "bg-cyan-700/18"
    ]
  },
  {
    id: "hero-amber",
    base: "bg-linear-to-br from-slate-950 via-amber-950 to-slate-950 animate-gradient",
    orbs: [
      "bg-amber-500/24",
      "bg-orange-500/20",
      "bg-yellow-400/14",
      "bg-rose-400/14",
      "bg-amber-700/16"
    ]
  }
];
var AUTH_LOGIN_SCENE_IDS_EXCLUDED_FROM_AUTH_LAYOUT = [
  "hero-emerald",
  "hero-amber"
];
var AUTH_LAYOUT_EXCLUDED_IDS = new Set(
  AUTH_LOGIN_SCENE_IDS_EXCLUDED_FROM_AUTH_LAYOUT
);
function pickRandomAuthLoginScene() {
  const i = Math.floor(Math.random() * AUTH_LOGIN_SCENES.length);
  return AUTH_LOGIN_SCENES[i];
}
function pickRandomAuthLayoutBackgroundScene() {
  const eligible = AUTH_LOGIN_SCENES.filter((s) => !AUTH_LAYOUT_EXCLUDED_IDS.has(s.id));
  const i = Math.floor(Math.random() * eligible.length);
  return eligible[i];
}
var SURFACE_CARD_LIGHT_INDO = "rounded-2xl border border-indigo-200/80 bg-gradient-to-br from-indigo-50/90 via-white to-violet-50/40 shadow-sm";
var ACCENT_BTN_INDO_VO = "bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-500 hover:to-violet-500 text-white shadow-md";
var ACCENT_BTN_GREEN = "bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white shadow-md";
var TEXT_GRADIENT_GREEN_CLASS = "text-gradient-green";

export { ACCENT_BTN_GREEN, ACCENT_BTN_INDO_VO, AUTH_LOGIN_SCENES, AUTH_LOGIN_SCENE_IDS_EXCLUDED_FROM_AUTH_LAYOUT, IMOBDESK_TOKENS_META, SURFACE_CARD_LIGHT_INDO, SURFACE_HERO_DARK_INDO, TEXT_GRADIENT_GREEN_CLASS, pickRandomAuthLayoutBackgroundScene, pickRandomAuthLoginScene };
//# sourceMappingURL=marketing.mjs.map
//# sourceMappingURL=marketing.mjs.map